import React from "react";
import MappaHome from "../components/home/MappaHome";

const MappaPage = () => {
    return (
        <MappaHome />
    );
};

export default MappaPage;